import { FunctionComponent } from 'react';
import GenericDeleteModal from 'components/UI/V3/Modals/DeleteModal/GenericDeleteModal';
import styles from './DeleteSaleConfirm.module.scss';

interface DeleteSaleConfirmProps {
    deleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const DeleteSaleConfirm: FunctionComponent<DeleteSaleConfirmProps> = ({ deleting, onCancel, onConfirm }) => (
    <GenericDeleteModal
        className={styles.modal}
        zIndex={30000}
        isLoading={deleting}
        title={<h3 className={styles.title}>Delete Sale</h3>}
        body={
            <p className={styles.description}>
                Are you sure you want to <strong>delete</strong> this sale?
                <br />
                This action cannot be undone.
            </p>
        }
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);

export default DeleteSaleConfirm;
